import { Link } from "react-router-dom";

interface EmptyPreviewProps {
  message: string;
  actionLabel: string;
  to: string;
  brandColor: string;
}

/**
 * Shared empty state for a lifecycle band. Deliberately not a dead grey box —
 * an empty band is still a real state with a real next step.
 */
export const EmptyPreview = ({ message, actionLabel, to, brandColor }: EmptyPreviewProps) => (
  <div
    className="rounded-xl border border-dashed px-4 py-4"
    style={{ borderColor: `${brandColor}40`, backgroundColor: `${brandColor}08` }}
  >
    <p className="text-sm text-gray-600">{message}</p>
    <Link
      to={to}
      className="mt-2 inline-flex text-sm font-semibold hover:underline"
      style={{ color: brandColor }}
    >
      {actionLabel}
    </Link>
  </div>
);

/**
 * Shared failure state. One band failing shows this inline and leaves every
 * other band on screen — the dashboard never blanks.
 */
export const PreviewError = ({ label }: { label: string }) => (
  <div className="rounded-xl border border-gray-200 bg-[#F9FAFC] px-4 py-4">
    <p className="text-sm text-gray-600">
      We couldn't load your {label} just now. The rest of your dashboard is still current.
    </p>
  </div>
);
